import { connect } from 'react-redux';
//
import FloorOptionModal from 'components/formula-entry/modals/floor-option/floor-option';
import { cancelFormulaEdit, updateMarkerList } from 'store/formula-entry/actions';
import { IStoreState } from 'store';
import { updateProductField } from 'store/deal-edit/actions';
import { setLoading } from 'store/loading/actions';
import { getDealEvaluation } from 'store/deal-evaluation/actions';
import { getAllMarkersList } from '../formula-list/selectors/selectors';

const mapStateToProps = (state: IStoreState) => {
  const { formulaEntry, dealEdit } = state;
  return {
    dealEdit,
    formulaEntry,
    allTypesMarkerList: getAllMarkersList(state),
  };
};

const mapDispatchToProps = {
  cancelFormulaEdit,
  getDealEvaluation,
  setLoading,
  updateProductField,
  updateMarkerList,
};
export default connect(mapStateToProps, mapDispatchToProps)(FloorOptionModal);
